import { fetchActionFactory } from '../../shared/store/fetchFactory';
import {
  addAttachments as addAttachmentsApi,
} from '../../shared/api';
import {
  fetchCountryTaxTypes as fetchCountryTaxTypesApi,
  fetchTaxEntries as fetchTaxEntriesApi,
  fetchNotifications as fetchNotificationsApi,
  fetchDiagnostics as fetchDiagnosticsApi,
  fetchTaxEntryData as fetchTaxEntryDataApi,
  fetchSubledgerTaxEntries as fetchSubledgerTaxEntriesApi,
  fetchSubledgerGlAccounts as fetchSubledgerGlAccountsApi,
  fetchProposedJournals as fetchProposedJournalsApi,
  submitTaxEntry as submitTaxEntryApi,
  approveTaxEntries as approveTaxEntriesApi,
  declineTaxEntries as declineTaxEntriesApi,
  fetchTaxEntryForApprovalAttachments as fetchTaxEntryForApprovalAttachmentsApi,
  unlockTaxEntriesForApproval as unlockTaxEntriesForApprovalApi,
  fetchProposedJournalsForReclass as fetchProposedJournalsForReclassApi,
  submitTaxEntries as submitTaxEntriesApi,
  fetchTaxEntriesTree as fetchTaxEntriesTreeApi,
  fetchDeferredTaxRate as fetchDeferredTaxRateApi,
  fetchObligationRates as fetchObligationRatesApi,
  fetchTypeDescriptions as fetchTypeDescriptionsApi,
  fetchActivityDescriptions as fetchActivityDescriptionsApi,
  fetchTbeErrors as fetchTbeErrorsApi,
} from '../api';
import {
  fetchTaxEntriesForApproval as fetchTaxEntriesForApprovalSocket,
} from '../sockets';
import {
  selectCompanyCode,
  selectPeriod,
  selectTaxYear,
  selectBookType,
  fetchingError,
  fetchCompanyCodeDetails,
  fetchTaxYears,
  selectConnection,
  fetchConnections,
  fetchAccounts,
} from '../../shared/store/actions';
import {
  errorNotification,
  infoNotification,
  warningNotification,
  successNotification,
} from '../../shared/store/notificationActions';

import {
  FETCH_COUNTRY_TAX_TYPES,
  FETCH_COUNTRY_TAX_TYPES_SUCCESS,
  SELECT_COUNTRY_TAX_TYPE,
  FETCH_TAX_ENTRIES,
  FETCH_TAX_ENTRIES_SUCCESS,
  RESET_TAX_ENTRIES,
  FETCH_TAX_ENTRY_DATA,
  FETCH_TAX_ENTRY_DATA_SUCCESS,
  SHOW_ADD_ENTRY_MODAL,
  HIDE_ADD_ENTRY_MODAL,
  FETCH_SUBLEDGER_TAX_ENTRIES,
  FETCH_SUBLEDGER_TAX_ENTRIES_SUCCESS,
  FETCH_PROPOSED_JOURNALS,
  FETCH_PROPOSED_JOURNALS_SUCCESS,
  FETCH_PROPOSED_JOURNALS_FAILURE,
  FETCH_SUBLEDGER_GL_ACCOUNTS,
  FETCH_SUBLEDGER_GL_ACCOUNTS_SUCCESS,
  RESET_PROPOSED_JOURNALS,
  FETCH_TAX_ENTRIES_FOR_APPROVAL,
  FETCH_TAX_ENTRIES_FOR_APPROVAL_SUCCESS,
  UNLOCK_TAX_ENTRIES_FOR_APPROVAL,
  SELECT_PERIOD_FROM,
  SELECT_PERIOD_TO,
  FETCH_TAX_ENTRY_FOR_APPROVAL_DATA_SUCCESS,
  RESET_DATA_FOR_APPROVE_TAX_ENTRY_PAGE,
  RESET_TAX_ENTRY_FOR_APPROVAL_DATA,
  FETCH_NOTIFICATIONS,
  FETCH_NOTIFICATIONS_SUCCESS,
  RESET_DATA_FOR_NOTIFICATIONS_PAGE,
  FETCH_PROPOSED_RECLASS_JOURNALS,
  FETCH_PROPOSED_RECLASS_JOURNALS_SUCCESS,
  FETCH_PROPOSED_RECLASS_JOURNALS_FAILURE,
  FETCH_TAX_ENTRIES_FOR_APPROVAL_FAILURE,
  FETCH_TAX_ENTRIES_FAILURE,
  FETCH_DIAGNOSTICS,
  FETCH_DIAGNOSTICS_SUCCESS,
  FETCH_DIAGNOSTICS_FAILURE,
  SUBMIT_DIRECT_TAX_ENTRIES,
  SUBMIT_DIRECT_TAX_ENTRIES_SUCCESS,
  SUBMIT_DIRECT_TAX_ENTRIES_FAILURE,
  REVIEW_TAX_ENTRIES,
  REVIEW_TAX_ENTRIES_FAILURE,
  FETCH_TAX_ENTRIES_TREE,
  FETCH_TYPE_DESCRIPTIONS,
  FETCH_ACTIVITY_DESCRIPTIONS,
  REVIEW_TAX_ENTRIES_SUCCESS,
  REVIEW_TAX_ENTRIES_PROGRESS,
  REVIEW_TAX_ENTRIES_CANCELLED,
  SUBMIT_TAX_ENTRY,
  SUBMIT_TAX_ENTRY_SUCCESS,
  SUBMIT_TAX_ENTRY_FAILURE,
  FETCH_DEFERRED_TAX_RATE,
  FETCH_OBLIGATION_RATES,
  FETCH_TBE_ERRORS,
} from './types';
import chunkExport from '../../shared/chunkExport';
import {
  DECLINING_TAX_ENTRIES_CHUNK_SIZE,
  REVIEWING_TAX_ENTRIES_CHUNK_SIZE,
} from '../approveTaxEntriesPage/constants';

import { CountryTaxTypeStaticOptions } from '../../../src/shared/constants';

export const fetchCountryTaxTypes = (companyCode, period, staticOptions ) => async (dispatch, getState) => {
  const fetchCountryTaxTypesSuccess = (countryTaxTypes, currentlySelectedCountryTaxType) => {
    const isCurrentlySelectedInTheCollection = !currentlySelectedCountryTaxType ? false : countryTaxTypes
      .map(taxType => taxType.countryTaxType)
      .includes(currentlySelectedCountryTaxType.value);

    let countryTaxTypeToSelect = null;

    if (isCurrentlySelectedInTheCollection) {
      countryTaxTypeToSelect = currentlySelectedCountryTaxType;
    } else if (countryTaxTypes[0]) {
      countryTaxTypeToSelect = {
        value: countryTaxTypes[0].countryTaxType,
        label: countryTaxTypes[0].description,
      };
    }

    return {
      type: FETCH_COUNTRY_TAX_TYPES_SUCCESS,
      countryTaxTypes,
      countryTaxType: countryTaxTypeToSelect,
    };
  };

  if (!companyCode || !period) {
    return;
  }

  try {
    dispatch({
      type: FETCH_COUNTRY_TAX_TYPES,
    });

    const responseData = await fetchCountryTaxTypesApi({
      companyCode,
      period: period.name,
      staticOptions,
    });

    const { countryTaxType: currentlySelectedCountryTaxType } = getState().balanceSheetManagement.shared;

    return dispatch(fetchCountryTaxTypesSuccess(responseData, currentlySelectedCountryTaxType));
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

const fetchTaxEntries = ({
  companyCode,
  countryTaxType,
  period,
  taxYear,
  bookType,
}) => async dispatch => {
  const fetchTaxEntriesSuccess = taxEntries => ({
    type: FETCH_TAX_ENTRIES_SUCCESS,
    taxEntries,
  });

  try {
    if (!(companyCode && countryTaxType && period && taxYear && bookType)) {
      return;
    }

    dispatch({
      type: FETCH_TAX_ENTRIES,
    });

    const responseData = await fetchTaxEntriesApi({
      companyCode,
      countryTaxType: countryTaxType.value,
      period: period.name,
      taxYear: taxYear.value,
      bookType,
    });

    return dispatch(fetchTaxEntriesSuccess(responseData));
  } catch (error) {
    dispatch({
      type: FETCH_TAX_ENTRIES_FAILURE,
    });

    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

const fetchNotifications = ({ period, connection }) =>
  async dispatch => {
    const fetchNotificationsSuccess = notifications => ({
      type: FETCH_NOTIFICATIONS_SUCCESS,
      notifications,
    });

    try {
      if (!period) {
        return;
      }

      dispatch({
        type: FETCH_NOTIFICATIONS,
      });

      const responseData = await fetchNotificationsApi({
        period: period.name,
        connection,
      });

      return dispatch(fetchNotificationsSuccess(responseData));
    } catch (error) {
      if (error.isFetchingError) {
        dispatch(fetchingError());
        dispatch(errorNotification(error.message));
        return;
      }
      throw error;
    }
  };

const fetchDiagnostics = ({ period, connection }) =>
  async dispatch => {
    const fetchDiagnosticsSuccess = diagnostics => ({
      type: FETCH_DIAGNOSTICS_SUCCESS,
      diagnostics,
    });

    try {
      if (!period || !connection) {
        return;
      }

      dispatch({
        type: FETCH_DIAGNOSTICS,
      });

      const responseData = await fetchDiagnosticsApi({
        period: period.name,
        connection,
      });

      return dispatch(fetchDiagnosticsSuccess(responseData));
    } catch (error) {
      if (error.isFetchingError) {
        dispatch(fetchingError());
        dispatch(errorNotification(error.message));
        return dispatch({
          type: FETCH_DIAGNOSTICS_FAILURE,
        });
      }
      throw error;
    }
  };

export const resetTaxEntries = () => ({
  type: RESET_TAX_ENTRIES,
});

export const selectPeriodForTaxEntries = period => async (dispatch, getState) => {
  dispatch(selectPeriod(period));

  const state = getState();
  const { companyCode, bookType, taxYear } = state.shared;

  await dispatch(fetchCountryTaxTypes(companyCode, period, CountryTaxTypeStaticOptions.ALL));
  await dispatch(fetchCompanyCodeDetails(companyCode, period));

  const { countryTaxType } = state.balanceSheetManagement.shared;

  return dispatch(fetchTaxEntries({
    bookType,
    companyCode,
    countryTaxType,
    period,
    taxYear,
  }));
};

export const selectPeriodForNotifications = period => async (dispatch, getState) => {
  dispatch(selectPeriod(period));

  await dispatch(fetchConnections(period, {
    limitToAssigned: true,
    limitToSubledgerEnabled: true,
    setAllConnectionsByDefault: true,
  }));

  const state = getState();
  const { connection } = state.shared;

  return dispatch(fetchNotifications({
    connection: connection.connName,
    period,
  }));
};

export const selectConnectionForNotifications = connection => (dispatch, getState) => {
  dispatch(selectConnection(connection));

  const state = getState();
  const { period } = state.shared;

  return dispatch(fetchNotifications({
    connection,
    period,
  }));
};

export const selectCompanyCodeForTaxEntries = companyCode => async (dispatch, getState) => {
  dispatch(selectCompanyCode(companyCode));

  const { period } = getState().shared;

  await dispatch(fetchCountryTaxTypes(companyCode, period, CountryTaxTypeStaticOptions.ALL));
  await dispatch(fetchCompanyCodeDetails(companyCode, period));

  const state = getState();
  const { bookType, taxYear } = state.shared;
  const { countryTaxType } = state.balanceSheetManagement.shared;

  return dispatch(fetchTaxEntries({
    bookType,
    companyCode,
    countryTaxType,
    period,
    taxYear,
  }));
};

export const selectTaxYearForTaxEntries = taxYear => async (dispatch, getState) => {
  dispatch(selectTaxYear(taxYear));

  const state = getState();
  const { bookType, companyCode, period } = state.shared;
  const { countryTaxType } = state.balanceSheetManagement.shared;

  return dispatch(fetchTaxEntries({
    bookType,
    companyCode,
    countryTaxType,
    period,
    taxYear,
  }));
};

export const selectCountryTaxType = countryTaxType => ({
  type: SELECT_COUNTRY_TAX_TYPE,
  countryTaxType,
});

export const selectCountryTaxTypeForTaxEntries = countryTaxType => async (dispatch, getState) => {
  dispatch(selectCountryTaxType(countryTaxType));

  const state = getState();
  const { bookType, companyCode, period, taxYear } = state.shared;

  await dispatch(fetchTaxEntries({
    bookType,
    companyCode,
    countryTaxType,
    period,
    taxYear,
  }));
};

export const selectBookTypeForTaxEntries = bookType => async (dispatch, getState) => {
  dispatch(selectBookType(bookType));

  const state = getState();
  const { companyCode, period, taxYear } = state.shared;
  const { countryTaxType } = state.balanceSheetManagement.shared;

  dispatch(fetchTaxEntries({
    bookType,
    companyCode,
    countryTaxType,
    period,
    taxYear,
  }));
};

export const selectPeriodForDiagnostics = period => async (dispatch, getState) => {
  dispatch(selectPeriod(period));

  await dispatch(fetchConnections(period, {
    limitToAssigned: true,
    limitToSubledgerEnabled: true,
    includeAllOption: false,
  }));

  const state = getState();
  const { connection } = state.shared;

  return dispatch(fetchDiagnostics({
    connection: connection.connName,
    period,
  }));
};

export const selectConnectionForDiagnostics = connection => (dispatch, getState) => {
  dispatch(selectConnection(connection));

  const state = getState();
  const { period } = state.shared;

  return dispatch(fetchDiagnostics({
    connection,
    period,
  }));
};

export const fetchTaxEntryData = taxEntryId => async dispatch => {
  const fetchTaxEntryDataSuccess = (taxEntryId, taxEntryData) => ({
    type: FETCH_TAX_ENTRY_DATA_SUCCESS,
    taxEntryData,
    taxEntryId,
  });

  try {
    dispatch({
      type: FETCH_TAX_ENTRY_DATA,
    });

    const responseData = await fetchTaxEntryDataApi(taxEntryId);

    dispatch(fetchTaxEntryDataSuccess(taxEntryId, responseData));
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const fetchInitialDataForViewTaxEntryPage = isCorrectCompanyCodeSelected => async (dispatch, getState) => {
  if (isCorrectCompanyCodeSelected) {
    await dispatch(fetchTaxYears());

    const { companyCode, bookType, period, taxYear } = getState().shared;

    if (!companyCode || !period) {
      return;
    }

    await dispatch(fetchCountryTaxTypes(companyCode, period, CountryTaxTypeStaticOptions.ALL));
    await dispatch(fetchCompanyCodeDetails(companyCode, period));

    const { countryTaxType } = getState().balanceSheetManagement.shared;

    dispatch(fetchTaxEntries({
      bookType,
      companyCode,
      countryTaxType,
      period,
      taxYear,
    }));
  }
};

export const fetchInitialDataForNotificationsPage = () => async (dispatch, getState) => {
  const { period } = getState().shared;

  await dispatch(fetchConnections(period, {
    limitToAssigned: true,
    setAllConnectionsByDefault: true,
    includeAllOption: true,
  }));

  const { connection } = getState().shared;

  dispatch(fetchNotifications({ period, connection: connection.connName }));
};


export const fetchInitialDataForDiagnosticsPage = () => async (dispatch, getState) => {
  const { period } = getState().shared;

  await dispatch(fetchConnections(period, {
    limitToAssigned: true,
    includeAllOption: false,
  }));

  const { connection } = getState().shared;

  dispatch(fetchDiagnostics({ period, connection: connection.connName }));
};

export const resetDataForNotificationsPage = () => ({
  type: RESET_DATA_FOR_NOTIFICATIONS_PAGE,
});

export const showAddEntryModal = () => ({
  type: SHOW_ADD_ENTRY_MODAL,
});

export const hideAddEntryModal = () => ({
  type: HIDE_ADD_ENTRY_MODAL,
});

export const fetchSubledgerTaxEntries = ({
  companyCode,
  period,
  selectTaxYearFromCurrentPeriod = false,
}) => async (dispatch, getState) => {
  const fetchSubledgerTaxEntriesSuccess = (subledgerTaxEntries = []) => ({
    type: FETCH_SUBLEDGER_TAX_ENTRIES_SUCCESS,
    subledgerTaxEntries,
  });

  if (!companyCode || !period) {
    return;
  }

  try {
    dispatch({
      type: FETCH_SUBLEDGER_TAX_ENTRIES,
    });

    const taxEntriesResponse = await fetchSubledgerTaxEntriesApi({
      companyCode,
      period: period.name,
    });

    if (selectTaxYearFromCurrentPeriod) {
      const currentPeriod = getState().shared.currentPeriod;
      const foundTaxYear = taxEntriesResponse.taxYears.find(taxYear => taxYear.year === currentPeriod.taxYear);

      if (foundTaxYear) {
        dispatch(selectTaxYear({ value: foundTaxYear.year, name: foundTaxYear.year }));
      }
    }

    return dispatch(fetchSubledgerTaxEntriesSuccess(taxEntriesResponse.taxYears));
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const fetchSubledgerGlAccounts = period => async dispatch => {
  const fetchSubledgerGlAccountsSuccess = (subledgerGlAccounts = []) => ({
    type: FETCH_SUBLEDGER_GL_ACCOUNTS_SUCCESS,
    subledgerGlAccounts,
  });

  if (!period) {
    return;
  }

  try {
    dispatch({
      type: FETCH_SUBLEDGER_GL_ACCOUNTS,
    });

    const glAccountsResponse = await fetchSubledgerGlAccountsApi({
      period: period.name,
    });

    return dispatch(fetchSubledgerGlAccountsSuccess(glAccountsResponse));
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const fetchProposedJournals = ({
  companyCode,
  period,
  taxYear,
  countryTaxType,
  entryType,
  entryActivity,
  amount,
  netAmount,
  grossAmount,
  topsideFlag,
  bookType,

  glAccountOverride,
  account,
  fromAccount,
  allowGross,
}) => async dispatch => {
  const fetchProposedJournalsSuccess = proposedJournals => ({
    type: FETCH_PROPOSED_JOURNALS_SUCCESS,
    proposedJournals,
  });

  try {
    dispatch({
      type: FETCH_PROPOSED_JOURNALS,
    });

    const responseData = await fetchProposedJournalsApi({
      companyCode,
      period: period.name,
      taxYear,
      countryTaxType,
      entryType,
      entryActivity,
      netAmount: netAmount || amount,
      grossAmount,
      topsideFlag,
      bookType,

      glAccountOverride,
      account,
      fromAccount,
      allowGross,
    });

    return dispatch(fetchProposedJournalsSuccess(responseData));
  } catch (error) {
    dispatch({
      type: FETCH_PROPOSED_JOURNALS_FAILURE,
    });
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const resetProposedJournals = () => (dispatch, getState) => {
  const { slJournal, slDeferredBalance } = getState().balanceSheetManagement.shared.proposedJournals;
  const proposedJournalsForReclass = getState().balanceSheetManagement.shared.proposedJournalsForReclass;

  const areTaxEntriesProposedJournalsEmpty = !slJournal.length || !slDeferredBalance.length;
  const areReclassProposedJournalsEmpty = !proposedJournalsForReclass.length;

  if (areTaxEntriesProposedJournalsEmpty && areReclassProposedJournalsEmpty) {
    return;
  }

  return dispatch({
    type: RESET_PROPOSED_JOURNALS,
  });
};

export const submitTaxEntry = ({
  companyCode,
  period,
  taxYear,
  countryTaxType,
  entryType,
  entryActivity,
  netAmount,
  grossAmount,
  comment,
  topsideFlag,
  fbosFlag,
  bookType,
  payableTag,

  glAccountOverride,
  account,
  fromAccount,

  attachments,
  canUnlinkNetGrossAmount,
}) => async dispatch => {
  try {
    dispatch(infoNotification('Saving attachments'));
    dispatch({ type: SUBMIT_TAX_ENTRY });
    const uploadedAttachments = await addAttachmentsApi(attachments);

    const attachmentsWithIds = attachments.map((attachment, index) => ({
      ...attachment,
      attachmentId: uploadedAttachments[index].attachmentId,
    }));

    await submitTaxEntryApi({
      companyCode,
      periodName: period.name,
      taxYear,
      countryTaxType,
      entryType,
      entryActivity,
      netAmount: Number(netAmount),
      grossAmount: grossAmount === '' || !canUnlinkNetGrossAmount ? '' : Number(grossAmount),
      comment,
      topsideFlag,
      fbosFlag,
      bookType,
      glAccountOverride,
      account,
      fromAccount,
      payableTag,
      files: attachmentsWithIds,
    });

    dispatch(successNotification('Tax entry successfully saved'));
    dispatch(resetProposedJournals());
    dispatch({ type: SUBMIT_TAX_ENTRY_SUCCESS });
  } catch (error) {
    dispatch({ type: SUBMIT_TAX_ENTRY_FAILURE });
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const fetchInitialDataForAddTaxEntryPage = (
  {
    companyCode,
    currentPeriod,

    isCorrectCompanyCodeSelected,
  },
  callback
) => async (dispatch, getState) => {
  dispatch(resetProposedJournals());

  if (isCorrectCompanyCodeSelected) {
    await dispatch(fetchSubledgerTaxEntries({ companyCode, period: currentPeriod }));
  }

  await dispatch(fetchSubledgerGlAccounts(currentPeriod));
  await dispatch(fetchAccounts());

  const { subledgerTaxEntries } = getState().balanceSheetManagement.shared;
  callback(subledgerTaxEntries);
};

export const fetchTaxEntriesForApproval = ({
  currentPeriod,
  socket,
}) => async dispatch => {
  dispatch({
    type: FETCH_TAX_ENTRIES_FOR_APPROVAL,
  });

  try {
    const taxEntriesResponse = await fetchTaxEntriesForApprovalSocket(socket)({
      periodName: currentPeriod.name,
    });

    return dispatch({
      type: FETCH_TAX_ENTRIES_FOR_APPROVAL_SUCCESS,
      taxEntriesForApproval: taxEntriesResponse.taxEntries,
      lockId: taxEntriesResponse.lockId,
    });
  } catch (error) {
    dispatch({
      type: FETCH_TAX_ENTRIES_FOR_APPROVAL_FAILURE,
    });

    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const fetchInitialDataForApproveTaxEntryPage = socket => async (dispatch, getState) => {
  const currentPeriod = getState().shared.currentPeriod;

  dispatch(fetchTaxEntriesForApproval({
    currentPeriod,
    socket,
  }));
};

export const unlockTaxEntriesForApproval = () => async (dispatch, getState) => {
  const lockId = getState().balanceSheetManagement.shared.lockIdForTaxEntriesBatch;
  if (lockId) {
    await unlockTaxEntriesForApprovalApi(lockId);
    await dispatch({
      type: UNLOCK_TAX_ENTRIES_FOR_APPROVAL,
    });
  }
};

export const resetDataForApproveTaxEntryPage = () => async dispatch => {
  await dispatch({
    type: RESET_DATA_FOR_APPROVE_TAX_ENTRY_PAGE,
  });
  dispatch({ type: REVIEW_TAX_ENTRIES_CANCELLED });
  dispatch(resetProposedJournals());
  dispatch(unlockTaxEntriesForApproval());
};

export const resetTaxEntryForApprovalData = () => async dispatch => {
  await dispatch({
    type: RESET_TAX_ENTRY_FOR_APPROVAL_DATA,
  });
  dispatch(resetProposedJournals());
};

const cancelApprovingExceptionFactory = () => ({ wasReviewCancelled: true });

export const setReviewTaxEntriesProgress = progress => ({
  type: REVIEW_TAX_ENTRIES_PROGRESS,
  progress,
});

export const chunkTaxEntriesReview = ({ taxEntryIds, reviewComment, lockId, reviewTaxEntriesApi, chunkSize }) =>
  async (dispatch, getState) => {
    const submitToApi = taxEntryIds => {
      const isReviewInProgress = getState().balanceSheetManagement.shared.taxEntriesReviewInProgress;
      const isDeclineInProgress = getState().balanceSheetManagement.shared.taxEntriesDeclineInProgress;

      if (!isReviewInProgress && !isDeclineInProgress) {
        throw cancelApprovingExceptionFactory();
      }
      return reviewTaxEntriesApi({ taxEntryIds, reviewComment, lockId });
    };

    await chunkExport(
      taxEntryIds,
      chunkSize,
      submitToApi,
      progress => dispatch(setReviewTaxEntriesProgress(progress))
    );
  };

export const reviewTaxEntries = ({
  taxEntryIds,
  reviewComment,
  type,
  lockId,
  socket,
}) => async (dispatch, getState) => {
  const currentPeriod = getState().shared.currentPeriod;

  try {
    // reviewTaxEntriesActions started
    dispatch({ type: REVIEW_TAX_ENTRIES, reviewType: type });

    if (type === 'approve') {
      await dispatch(chunkTaxEntriesReview({
        taxEntryIds,
        reviewComment,
        lockId,
        reviewTaxEntriesApi: approveTaxEntriesApi,
        chinkSize: REVIEWING_TAX_ENTRIES_CHUNK_SIZE,
      }));

      await dispatch({ type: REVIEW_TAX_ENTRIES_SUCCESS });
      // reviewTaxEntriesActions approve finished - will unlock
      await dispatch(unlockTaxEntriesForApproval());
      // reviewTaxEntriesActions approve finished - unlocked - will fetch
      await dispatch(fetchTaxEntriesForApproval({ currentPeriod, socket }));
      // reviewTaxEntriesActions approve finished - unlocked - fetched - will display success notification
      return dispatch(successNotification('Tax entries successfully approved'));
    }

    await dispatch(chunkTaxEntriesReview({
      taxEntryIds,
      reviewComment,
      lockId,
      reviewTaxEntriesApi: declineTaxEntriesApi,
      chunkSize: DECLINING_TAX_ENTRIES_CHUNK_SIZE,
    }));

    await dispatch({ type: REVIEW_TAX_ENTRIES_SUCCESS });
    // reviewTaxEntriesActions decline finished - will unlock
    await dispatch(unlockTaxEntriesForApproval());
    // reviewTaxEntriesActions decline finished - unlocked - will fetch
    await dispatch(fetchTaxEntriesForApproval({ currentPeriod, socket }));
    // reviewTaxEntriesActions decline finished - unlocked - fetched - will display success notification
    return dispatch(successNotification('Tax entries successfully declined'));
  } catch (error) {
    dispatch({ type: REVIEW_TAX_ENTRIES_FAILURE });
    if (error.isTimeoutError) {
      dispatch(fetchingError());
      dispatch(warningNotification('Request timed out. Processing will continue in the background.'));
      return;
    }
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }

    if (error.wasReviewCancelled) {
      return;
    }

    throw error;
  }
};

export const fetchTaxEntryForApprovalData = taxEntry => async dispatch => {
  const fetchTaxEntryForApprovalDataSuccess = taxEntryData => ({
    type: FETCH_TAX_ENTRY_FOR_APPROVAL_DATA_SUCCESS,
    taxEntryData,
  });

  try {
    await dispatch(fetchProposedJournals({
      netAmount: taxEntry.netAmount,
      grossAmount: taxEntry.grossAmount,
      bookType: taxEntry.bookType,
      companyCode: taxEntry.companyCode,
      countryTaxType: taxEntry.countryTaxType,
      entryActivity: taxEntry.taxEntryActivity,
      entryType: taxEntry.taxEntryType,
      account: taxEntry.account,
      fromAccount: taxEntry.fromAccount,
      glAccountOverride: taxEntry.glAccountOffsetDescription,
      period: { name: taxEntry.periodName },
      taxYear: taxEntry.taxYear,
      topsideFlag: taxEntry.topsideFlag,
    }));

    const attachments = await fetchTaxEntryForApprovalAttachmentsApi(taxEntry.taxEntryId);

    return dispatch(fetchTaxEntryForApprovalDataSuccess({
      attachments,
      taxEntryId: taxEntry.taxEntryId,
    }));
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const selectPeriodFrom = periodFrom => ({
  type: SELECT_PERIOD_FROM,
  periodFrom,
});

export const selectPeriodTo = periodTo => ({
  type: SELECT_PERIOD_TO,
  periodTo,
});

export const fetchProposedJournalsForReclass = ({
  companyCode,
  period,
  taxYear,
  toTaxYear,
  countryTaxType,
  entryType,
  entryActivity,
  netAmount,
  grossAmount,
  netToAmount,
  grossToAmount,
  topsideFlag,
  bookType,
  account,
  toAccount,
  allowGross,
}) => async dispatch => {
  const fetchProposedJournalsSuccess = proposedJournals => ({
    type: FETCH_PROPOSED_RECLASS_JOURNALS_SUCCESS,
    proposedJournals,
  });
  try {
    dispatch({
      type: FETCH_PROPOSED_RECLASS_JOURNALS,
    });

    const responseData = await fetchProposedJournalsForReclassApi({
      companyCode,
      period: period.name,
      taxYear,
      toTaxYear,
      countryTaxType,
      entryType,
      entryActivity,
      netAmount,
      grossAmount,
      netToAmount,
      grossToAmount,
      topsideFlag,
      bookType,
      account,
      toAccount,
      allowGross,
    });

    return dispatch(fetchProposedJournalsSuccess(responseData));
  } catch (error) {
    if (error.isFetchingError) {
      dispatch({
        type: FETCH_PROPOSED_RECLASS_JOURNALS_FAILURE,
      });
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const submitReclassBalance = ({
  companyCode,
  period,
  taxYear,
  toTaxYear,
  countryTaxType,
  entryType,
  entryActivity,
  netAmount,
  grossAmount,
  netToAmount,
  grossToAmount,
  fbosFlag,
  topsideFlag,
  comment,
  bookType,
  account,
  toAccount,
  payableTag,
  glAccountOverride,
  attachments,
  canUnlinkNetGrossAmount,
}) => async dispatch => {
  try {
    dispatch(infoNotification('Saving attachments'));
    dispatch({ type: SUBMIT_TAX_ENTRY });
    const uploadedAttachments = await addAttachmentsApi(attachments);

    const attachmentsWithIds = attachments.map((attachment, index) => ({
      ...attachment,
      attachmentId: uploadedAttachments[index].attachmentId,
    }));

    const fromTaxEntry = {
      companyCode,
      periodName: period.name,
      taxYear,
      countryTaxType,
      entryType,
      entryActivity,
      netAmount: Number(netAmount),
      grossAmount: grossAmount === '' || !canUnlinkNetGrossAmount ? '' : Number(grossAmount),
      comment,
      topsideFlag,
      fbosFlag,
      transferFlag: true,
      bookType,
      payableTag,
      glAccountOverride,
      account,

      files: attachmentsWithIds,
    };

    const toTaxEntry = {
      companyCode,
      periodName: period.name,
      taxYear: toTaxYear,
      countryTaxType,
      entryType,
      entryActivity,
      netAmount: Number(netToAmount),
      grossAmount: grossToAmount === '' || !canUnlinkNetGrossAmount ? '' : Number(grossToAmount),
      comment,
      topsideFlag,
      fbosFlag,
      transferFlag: true,
      bookType,
      payableTag,
      glAccountOverride,
      account: toAccount,

      files: attachmentsWithIds,
    };

    await Promise.all([
      submitTaxEntryApi(fromTaxEntry),
      submitTaxEntryApi(toTaxEntry),
    ]);

    dispatch(successNotification('Reclass balance successfully saved'));
    dispatch(resetProposedJournals());
    dispatch({ type: SUBMIT_TAX_ENTRY_SUCCESS });
  } catch (error) {
    dispatch({ type: SUBMIT_TAX_ENTRY_FAILURE });
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const selectPeriodForAccountBalances = period => async dispatch => {
  dispatch(selectPeriod(period));
};

const getDirectEntryFiles = directEntries => directEntries.reduce((acc, directEntry, index) => {
  if (!directEntry || !directEntry.files.length) {
    return acc;
  }

  return acc.concat(directEntry.files.map(file => ({
    ...file,
    index,
  })));
}, []);

const addAttachmentsToDirectEntries = (directEntries, attachments) => directEntries.map((directEntry, index) => {
  const attachmentsForDirectEntry = attachments.filter(attachment => attachment.index === index);
  if (!attachments.length) {
    return directEntry;
  }

  return {
    ...directEntry,
    files: directEntry.files.map((file, index) => ({
      ...file,
      attachmentId: attachmentsForDirectEntry[index].attachmentId,
    })),
  };
});

export const submitDirectTaxEntries = (directEntries, { callback = null } = {}, isEnabled) => async dispatch => {
  dispatch({ type: SUBMIT_DIRECT_TAX_ENTRIES });

  try {
    if (!isEnabled) {
      dispatch(warningNotification('Obligation is disabled for this Company Code.'));
    } else {
      dispatch(infoNotification('Saving attachments'));
      const files = getDirectEntryFiles(directEntries);
      const attachments = await addAttachmentsApi(files);
      const directEntriesWithAttachments = addAttachmentsToDirectEntries(directEntries, attachments);

      await submitTaxEntriesApi(directEntriesWithAttachments);
      dispatch(successNotification('Direct Tax Entries successfully submited'));
      dispatch({
        type: SUBMIT_DIRECT_TAX_ENTRIES_SUCCESS,
      });

      if (callback) {
        callback();
      }
    }
  } catch (error) {
    dispatch({
      type: SUBMIT_DIRECT_TAX_ENTRIES_FAILURE,
      error: error.message,
    });
    dispatch(errorNotification(error.message));
  }
};

export const fetchTaxEntriesTree = fetchActionFactory(
  FETCH_TAX_ENTRIES_TREE,
  fetchTaxEntriesTreeApi,
  { field: 'taxEntriesTree' }
);

export const fetchDeferredTaxRate = fetchActionFactory(
  FETCH_DEFERRED_TAX_RATE,
  fetchDeferredTaxRateApi
);

export const fetchObligationRates = fetchActionFactory(
  FETCH_OBLIGATION_RATES,
  fetchObligationRatesApi
);

export const fetchTypeDescriptions = fetchActionFactory(
  FETCH_TYPE_DESCRIPTIONS,
  fetchTypeDescriptionsApi,
  { field: 'typeDescriptions' }
);

export const fetchActivityDescriptions = fetchActionFactory(
  FETCH_ACTIVITY_DESCRIPTIONS,
  fetchActivityDescriptionsApi,
  { field: 'activityDescriptions' }
);

export const fetchTbeErrors = fetchActionFactory(
  FETCH_TBE_ERRORS,
  fetchTbeErrorsApi,
  { field: 'tbeErrors' }
);
